export default __webpack_public_path__ + "static/media/vessel.ea3dfa64.jpg";